import { styled } from "../../../styles";

/**
 * Studies page styles (EN-5155). Generic admin chrome lives in
 * `shared/AdminPage.styles.ts`; only the signup-code cell belongs here.
 */

/**
 * The signup code with a copy button. The code is the point of the page —
 * an operator's job is to hand it to a site — so it reads as a value to be
 * taken, not as another table string.
 */
export const CodeCell = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
});

export const CodeValue = styled("code", {
  fontFamily: "monospace",
  fontSize: "13px",
  padding: "2px 6px",
  borderRadius: "4px",
  backgroundColor: "$gray-20",
  color: "$charcoal",
});

export const CopyCodeButton = styled("button", {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  height: "24px",
  padding: "0 8px",
  borderRadius: "4px",
  border: "1px solid $gray-40",
  backgroundColor: "$white",
  fontSize: "12px",
  fontFamily: "$openSans",
  color: "$gray-80",
  cursor: "pointer",

  "&:hover:not(:disabled)": {
    backgroundColor: "$gray-20",
    color: "$charcoal",
  },

  variants: {
    copied: {
      true: {
        borderColor: "$success-dark",
        color: "$success-dark",
      },
    },
  },
});
